import { render, staticRenderFns } from "./NewsListCardMobile.vue?vue&type=template&id=43071c43&"
import script from "./NewsListCardMobile.vue?vue&type=script&lang=js&"
export * from "./NewsListCardMobile.vue?vue&type=script&lang=js&"
import style0 from "./NewsListCardMobile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewsListCardMobile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports